import * as Yup from "yup";

const validationSchema = (schema: any) => {
  const valid = Yup.object({
    title: Yup.string().required(schema.isRequired),
    details: Yup.string().required(schema.isRequired),
    titleAr: Yup.string().required(schema.isRequired),
    detailsAr: Yup.string().required(schema.isRequired),
    longitude: Yup.number()
      .typeError(schema.isNumber)
      .required(schema.isRequired),
    latitude: Yup.number()
      .typeError(schema.isNumber)
      .required(schema.isRequired),
    publishDate: Yup.string().required(schema.isRequired),
    startDate: Yup.string().required(schema.isRequired),
    endDate: Yup.string().required(schema.isRequired),
    category: Yup.string().required(schema.isRequired),
    parking: Yup.array().of(Yup.string()),
    onlyForTenants: Yup.boolean()
  });
  return valid;
};

export default validationSchema;
